// extracted by mini-css-extract-plugin
export default {"hub-list":"styles_hub-list__ss2t1","hub-list__item":"styles_hub-list__item__5M44R","hub-list__item__link":"styles_hub-list__item__link__JCFhx"};